<app-filter-panel [(isOpen)]="isOpen"
                  [items]="cards()"
                  [definitions]="panelDefinitions()"
                  [selected]="panelSelected()"
                  itemNoun="lot"
                  title="Filter & Sort"
                  testId="cm-schedule-filter"
                  (applied)="onApplied($event)">
</app-filter-panel>
